import type { BaseTranslation } from "../i18n-types";

const ru = {
	WELCOME_LONG: "Добро пожаловать в Цифровой Зал Суда Unicorn",
	WELCOME: "Добро пожаловать, {name:string}!",
	JOIN_ROOM_DESCRIPTION:
		"Присоединитесь к комнате из списка ниже или создайте свою!",
	NO_ROOM: "Не видите нужную комнату? Создайте свою.",
	CREATE_ROOM: "Создать комнату",
	ROOM: "Комната",
	ACCESSIBILITY_SETTINGS: "Настройки доступности",
	ACCESSIBILITY_SETTINGS_DESCRIPTION: "Измените настройки доступности здесь",
	CONTRAST: "Контрастность",
	SELECT_DISPLAY_NAME:
		"Пожалуйста, введите отображаемое имя, которое вы хотите использовать",
	SOMETHING_WENT_WRONG: "Ой! Что-то пошло не так.",
	GO_BACK: "Вернуться",
	GO_BACK_TO_ROOM: "Вернуться в комнату",
	EXPAND: "Развернуть",
	EXPORT: "Экспорт",
	JOIN_ROOM: "Присоединиться к комнате",
	ROOM_ENDED_TITLE: "Комната закрыта",
	ROOM_ENDED_DESCRIPTION:
		"Комната закрыта, вы будете перенаправлены на главный экран",
	RENAME_FAILED: "Переименование не удалось.",
	TRANSCRIPT_DISCLAIMER:
		"Транскрипт на основе идентифицированных спикеров. Для идентификации необходимо говорить более 7 секунд.",
	CHANGE_SPEAKER_TITLE: "Изменить спикера",
	CHANGE_SPEAKER_DESCRIPTION: "измените имя и цвет спикера здесь",
	PREVIEW_MESSAGE: "Это предварительное сообщение",
	COLOR: "Цвет",
	NAME: "Имя",
	CANCEL: "Отмена",
	LANGUAGE: "Язык",
	SAVE: "Сохранить",
	ROOM_ID: "ID комнаты",
	ROOM_ID_FORM_PLACEHOLDER: "Введите ID комнаты для присоединения",
	ROOM_ID_FORM_REQUIRED: "ID комнаты необходим для присоединения",
	ROOM_ID_FORM_MIN_LENGTH: "ID комнаты должен содержать 17 символов",
	LOGIN: "Войти",
	ROOM_COL: "Комната:",
	LANGUAGE_COL: "Язык",
	END_ROOM: "Закрыть комнату",
	JOIN_NOW: "Присоединиться сейчас",
	LOGIN_FORM: {
		TOAST_TITLE: "Вход выполнен!",
		TOAST_DESCRIPTION:
			"Теперь вы можете создавать комнаты и присоединяться к ним!",
		DISPLAY_NAME: "Отображаемое имя",
		DISPLAY_NAME_FORM_PLACEHOLDER: "Введите отображаемое имя",
		DISPLAY_NAME_FORM_SHORT:
			"Отображаемое имя должно содержать минимум 3 символа",
		DISPLAY_NAME_FORM_LONG:
			"Отображаемое имя должно содержать максимум 32 символа",
		DISPLAY_NAME_FORM_REQUIRED: "Отображаемое имя обязательно",
	},
	PROFILE_FORM: {
		TITLE: "Заполните ваш профиль",
		DESCRIPTION: "Пожалуйста, введите отображаемое имя для начала",
		TOAST_SUCCESS_TITLE: "Профиль обновлён!",
		TOAST_SUCCESS_DESCRIPTION: "Ваш профиль был успешно сохранён.",
		TOAST_ERROR_TITLE: "Ошибка обновления",
		TOAST_ERROR_DESCRIPTION:
			"Не удалось обновить ваш профиль. Пожалуйста, попробуйте снова.",
		SUBMIT_BUTTON: "Сохранить профиль",
	},
	NO_ROOMS_LIST: "Упс, не удалось найти комнаты.",
	SEARCH_FOR_A_ROOM: "Поиск комнаты",
	AUTH_ERROR_DESCRIPTION:
		"Возникла проблема с аутентификацией. Пожалуйста, обновите страницу.",
	DELETE_CONFIRMATION_MODAL: {
		TITLE: "Удалить комнату",
		DESCRIPTION: "Вы уверены, что хотите удалить эту комнату?",
		CANCEL: "Отмена",
		DELETE: "Удалить",
	},
	CREATE_ROOM_TOAST: {
		TITLE: "Комната создана",
		DESCRIPTION: "Ваша комната готова для входа.",
	},
	CREATE_ROOM_FORM: {
		DESCRIPTION:
			"Установите имя для вашей комнаты, чтобы другие могли её видеть.",
		NAME_LABEL: "Название комнаты",
		NAME_PLACEHOLDER: "Введите название комнаты",
		LANGUAGE: "Язык",
		LANGUAGE_PLACEHOLDER: "Выберите язык",
		AUTO_DETECT: "Автоопределение",
		ENGLISH_US: "Английский (США)",
		ENGLISH_IN: "Английский (Индия)",
		ARABIC_KSA: "Арабский (Саудовская Аравия)",
		SPANISH_CR: "Испанский (Коста-Рика)",
		CATALAN_ES: "Каталанский (Испания)",
		PORTUGUESE_PT: "Португальский (Португалия)",
		PORTUGUESE_BR: "Португальский (Бразилия)",
		ESTONIAN_EE: "Эстонский (Эстония)",
		RUSSIAN_RU: "Русский (Россия)",
		MALTESE_MT: "Мальтийский (Мальта)",
		FILIPINO_PH: "Филиппинский (Филиппины)",
		SPANISH_MX: "Испанский (Мексика)",
		CHINESE_CN: "Китайский (Мандаринский)",
		VIETNAMESE_VN: "Вьетнамский (Вьетнам)",
		KOREAN_KR: "Корейский (Корея)",
		HINDI_IN: "Хинди (Индия)",
		PERSIAN_IR: "Персидский (Иран)",
		LANGUAGE_DESCRIPTION:
			"Выберите язык для комнаты, вы не сможете изменить язык комнаты позже.",

		INCPERSONDEFAULT: "Иванов,Иван",
		CDCDEFAULT: "AB1234",
		HEARINGTYPEDEFAULT: "Последующее слушание о пригодности",
		SCHEDULEDEFAULT: "28.11.2023, 10:30 МСК",
		ADVANCED: "Расширенные настройки",
		INCARCERATED_PERSON_PLACEHOLDER: "Введите ваше имя",
		CDC_PLACEHOLDER: "Введите номер CDC",
		HEARING_TYPE_PLACEHOLDER: "Введите тип слушания",
		INCARCERATED_PERSON: "Заключённый",
		CDC: "CDC",
		HEARING_TYPE: "Тип слушания",
		SCHEDULE: "Расписание",
		PICKDATE: "Выберите дату",
		STEP_DETAILS: "Детали",
		STEP_MODEL: "Модель",
		CONTINUE: "Продолжить",
		BACK: "Назад",
		MODEL_TITLE: "Модель транскрипции",
		MODEL_DESCRIPTION: "Choose the model everyone in this room starts with. You can lock it so participants keep it.",
		LOCK_MODEL: "Lock model for everyone",
		LOCK_MODEL_DESC: "Participants cannot change the transcription model in this room.",
		HOURS: "Часы",
		MINUTES: "Минуты",
		SECONDS: "Секунды",
	},
	EXPORT_MODAL: {
		TOAST_FAILED_TITLE: "Ошибка экспорта",
		TOAST_FAILED_DESCRIPTION: "Невозможно экспортировать пустой транскрипт.",
		DOWNLOAD: "Скачать",
		DOWNLOAD_DESCRIPTION:
			"Выберите формат для экспорта и включите дополнительные опции.",
		SELECT_FORMAT: "Выберите формат",
		SELECT_FORMAT_PLACEHOLDER: "Выберите формат экспорта",
		DOCUMENT: "Документ (.pdf)",
		SPREADSHEET: "Таблица (.csv)",
		AUDIO: "Аудио (.mp3)",
		DOCX: "Документ Word (.docx)",
	},
	TRANSLATE_DIALOG: {
		TITLE: "Перевод",
		BODY: "Хотите применить это изменение ко всем транскриптам этого пользователя?",
		APPLY_TO_SPEAKER: "Применить только к этому пользователю",
		APPLY_ONCE: "Применить только здесь",
		APPLY_TO_ALL: "Применить ко всем пользователям",

		TRANSLATE: "Перевести",
	},
	GUEST_FORM: {
		TITLE: "Гостевой доступ",
		DESCRIPTION:
			"Введите ваш адрес электронной почты, чтобы получить безопасную ссылку для входа",
		EMAIL_LABEL: "Адрес электронной почты",
		EMAIL_PLACEHOLDER: "Введите адрес электронной почты",
		EMAIL_REQUIRED: "Адрес электронной почты обязателен",
		EMAIL_INVALID: "Пожалуйста, введите действительный адрес электронной почты",
		SEND_LINK: "Отправить ссылку для входа",
		SUCCESS_TITLE: "Проверьте вашу электронную почту",
		SUCCESS_DESCRIPTION:
			"Мы отправили ссылку для входа на ваш адрес электронной почты. Нажмите на ссылку, чтобы получить доступ к комнате.",
		ERROR_TITLE: "Что-то пошло не так",
		ERROR_DESCRIPTION:
			"Не удалось отправить ссылку для входа. Пожалуйста, попробуйте снова.",
		CANCEL: "Отмена",
	},
	START_DATE_TIME: "Дата и время начала",
	END_DATE_TIME: "Дата и время окончания",
	REVERT_TO_ORIGINAL: "Вернуть к исходному",
	SELECTED_LANGUAGE: "Выбранный язык",
	TRANSLATION_INFO: "Некоторые транскрипты были переведены из исходного.",
	INVITE_GUEST: "Пригласить гостя",
	INVITE_GUEST_DESCRIPTION:
		"Пригласите гостевого пользователя в комнату, введя их имя и адрес электронной почты",
	CREATED_BY: "Создано кем",
	VIEW_ALL: "Посмотреть все",
	LOBBY: {
		LOBBY: "Лобби",
		WAITING_IN_LOBBY: "{name} ждет в лобби",
		USERS_WAITING_IN_LOBBY: "Управление пользователями, ожидающими в лобби.",
		SEND_INVITE: "Отправить приглашение",
		ADMIT: "Допустить",
		REJECT: "Отклонить",
		NO_PARTICIPANTS: "Нет участников в лобби.",
	},
	CLOSE: "Закрыть",
	LOGIN_PAGE: {
		CAROUSEL_STORY_1:
			"Испытайте транскрипцию в реальном времени с передовой технологией распознавания говорящих. Идеально подходит для встреч, интервью и конференций.",
		CAROUSEL_STORY_2:
			"Режим высокой контрастности, настраиваемые шрифты и поддержка нескольких языков обеспечивают эффективное использование нашей платформы всеми пользователями.",
		CAROUSEL_STORY_3:
			"Ваши разговоры защищены безопасностью корпоративного уровня. Присоединяйтесь к тысячам профессионалов, которые доверяют uTranscribe.",
		CAROUSEL_STORY_4:
			"Выберите способ идентификации ниже и начните транскрибировать за секунды. Сложная настройка не требуется.",
		CDCR_TEAM_TITLE: "Команда Tech Unicorn",
		CDCR_TEAM_SUBTITLE: "Проверенный участник",
		OR_CONTINUE_WITH: "или продолжите с",
		GUEST_ACCESS_SUBTITLE:
			"Не являетесь участником? Присоединяйтесь, используя ID встречи",
		WELCOME_TO: "Добро пожаловать в",
		CHOOSE_IDENTIFICATION: "Пожалуйста, выберите способ идентификации",
		NEED_HELP: "Нужна помощь? Свяжитесь с нашей службой поддержки.",
		CALL_SUPPORT: "Звоните 1-877-742-2135",
		EMAIL_SUPPORT: "Пишите на support@courtroom.tech",
	},
	SIZES: "Размеры",
	DIAGNOSTICS: "Диагностика",
	ROOM_BACKGROUND: "Фон комнаты",
	NOT_AVAILABLE: "Недоступно",
	UNRECOGNIZED_SPEECH: "Не распознано",
	UNRECOGNIZED_SPEECH_TOOLTIP:
		"Этот транскрипт не распознан. Пожалуйста, проверьте качество аудио и попробуйте снова.",
	UNDETECTED: "Не обнаружено",
	MICROPHONE_QUALITY_WARNING:
		"Пожалуйста, проверьте качество микрофона для повышения точности или отрегулируйте расстояние до микрофона",
	LOW_ACCURACY_WARNING: "Низкая точность",
	DIARIZATION: {
		UNDETECTED: "Не обнаружено",
		ACCURACY: "Точность",
		ID: "ID",
		LEXICAL: "Лексика",
		ITN: "ITN",
		MASKED_ITN: "ITN скрытый",
		LANGUAGE: "Язык",
		ORIGINAL_TEXT: "Оригинальный текст",
		SPEAKER: "Спикер",
	},
	UNKNOWN: "Неизвестно",
	TRANSCRIPTION_SETTINGS: {
		TRANSCRIPTION_SETTINGS: "Настройки транскрипции",
		GENERAL: "Общие",
		GENERAL_HINT: "Тема, шрифт и язык",
		MODE_HINT: "Поведение транскрипции",
		MODEL_HINT: "Движок обработки ИИ",
		MODE: "Режим",
		LIVE_TRANSCRIPTION: "Живая транскрипция",
		SEGMENTED_TRANSCRIPTION: "Сегментированная транскрипция",
		FINAL_TRANSCRIPTION: "Окончательная транскрипция",
		LIVE_DESC:
			"Просматривайте живую транскрипцию своей речи в отдельной панели во время разговора. Основная панель показывает окончательную транскрипцию для всех участников.",
		SEGMENTED_DESC:
			"Отображает временную сегментированную транскрипцию в реальном времени, автоматически обновляющуюся до окончательной версии.",
		FINAL_DESC:
			"Отображает только окончательную транскрипцию в основной панели. Живая транскрипция не показывается.",
		SPEED_VALUE: "Скорость: {value}x",
		SPEED: "Скорость",
		FONT_TEST:
			"UTranscribe совершает революцию в том, как мы записываем и понимаем речь.",
		FONT_SIZE: "Размер шрифта",
		SPEED_DESC: "Скорость и задержка транскрипции",
		DELAY_DESC: "Скорость {speed:number}x = задержка {delay:number} секунд",
		MODEL: "Модель",
		MODEL_TITLE: "Модель транскрипции",
		MODEL_DESC: "Выберите модель ИИ для обработки ваших транскрипций.",
		MODEL_DEFAULT: "Стандартная",
		MODEL_WHISPER: "Allicorn Model 1",
		MODEL_GPT4O: "Allicorn Model 2",
		MODEL_GPT4O_MINI: "Allicorn Model 3",
		MODEL_FAST: "Allicorn Model 4",
		MODEL_DEFAULT_DESC:
			"Служба диаризации Microsoft с быстрой обработкой и надежной точностью для большинства сценариев.",
		MODEL_DEFAULT_SHORT_DESC:
			"Быстрое и надежное разделение спикеров для большинства сценариев.",
		MODEL_WHISPER_DESC:
			"Allicorn Model 1 с повышенной точностью для сложных акустических условий и специализированной терминологии.",
		MODEL_WHISPER_SHORT_DESC:
			"Высокая точность для сложного аудио и специализированной терминологии.",
		MODEL_GPT4O_DESC:
			"Модель транскрипции Allicorn Model 2 с высочайшей точностью и пониманием языка.",
		MODEL_GPT4O_SHORT_DESC:
			"Высочайшая точность транскрипции и понимание языка.",
		MODEL_GPT4O_MINI_DESC:
			"Модель транскрипции Allicorn Model 3, сочетающая точность и скорость.",
		MODEL_GPT4O_MINI_SHORT_DESC:
			"Сбалансированная точность и скорость транскрипции.",
		MODEL_FAST_DESC:
			"Служба транскрипции Allicorn Model 4, оптимизированная для обработки с низкой задержкой.",
		MODEL_FAST_SHORT_DESC:
			"Обработка транскрипции с низкой задержкой.",
		MODEL_ENHANCED: "Улучшенная",
		MODEL_PREMIUM: "Premium",
		MODEL_BETA: "Beta",
		MODEL_BETA_TOOLTIP: "This feature is currently in beta. Expect occasional inaccuracies as we continue fine-tuning.",
		MODEL_LOCKED: "Model locked",
		MODEL_LOCKED_DESC: "The host fixed the transcription model when this room was created.",
		MODEL_LOCKED_HINT: "Locked by the room host.",
		DOMAIN_MATH_UNAVAILABLE: "Not available for the selected model.",
		DOMAIN_MATH: "Оптимизировано для математики",
		DOMAIN_MATH_DESC:
			"Отображает произнесенные математические символы и уравнения в виде настоящих математических обозначений, а не обычного текста.",
	},
	NO_AUDIO: "Звук не обнаружен",
	NO_AUDIO_DESC:
		"Ваш микрофон включен, но звук не обнаружен. Проверьте настройки микрофона или переключитесь на другой микрофон.",
	NO_TRANSCRIPTION: "Транскрипции не созданы",
	NO_TRANSCRIPTION_DESC:
		"Транскрипции не создаются. Пожалуйста, обновите страницу.",
	SCROLLING_PAUSED: "Прокрутка вниз приостановлена",
	RESUME: "Продолжить",
} satisfies BaseTranslation;

export default ru;
